export default __webpack_public_path__ + "static/faintmarks-6a0207b0865c3df8685d505821aee809.png";